import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import ReactMarkdown, {Components} from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import {renderTemplateVariables} from "../shared/surveyMarkdownText.util";

interface Props {
    /** The welcome or end screen title in the guest's language: single-line markdown with variables. */
    title: string
}

// A title is one paragraph; keep its formatting in the heading's own line flow.
const COMPONENTS: Components = {
    p: ({children, style}) => <Box component={'span'} style={style} sx={{display: 'block'}}>{children}</Box>,
    a: ({href, children}) => <a href={href} target={'_blank'} rel={'noopener noreferrer'}>{children}</a>,
};

/** The page's h1 on the welcome and end screens. */
function SurveyRunnerScreenTitle({title}: Props) {
    return (
        <Typography variant={'h4'} component={'h1'} sx={{overflowWrap: 'anywhere'}}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={COMPONENTS}>
                {renderTemplateVariables(title)}
            </ReactMarkdown>
        </Typography>
    );
}

export default SurveyRunnerScreenTitle;
